import { render, staticRenderFns } from "./UsersListFormItem.vue?vue&type=template&id=6d6f86fa&"
import script from "./UsersListFormItem.vue?vue&type=script&lang=ts&"
export * from "./UsersListFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports